import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { getCommonSearchList } from "../../services/settingsServices";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
  createMappingStore,
  mappingImportFile,
} from "../../services/MappingServices";
import Utils from "../../utils";
import ReactPaginate from "react-paginate";
import ConfigDB from "../../config";

const Mapping = () => {
  const { t } = useTranslation();
  const fileInputRef = useRef(null);
  const tableLengthList = ConfigDB.data.dataTableLength;

  const [mappingData, setMappingData] = useState({
    module_type: "",
    module_type_name: "",
  });
  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
  });

  const [moduleAllList, setModuleAllList] = useState([]);
  const [file, setFile] = useState(null);
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [mappingAllList, setMappingAllList] = useState([]);
  const [moduleColAllList, setModuleColAllList] = useState([]);
  const [columnMappings, setColumnMappings] = useState(
    moduleColAllList?.reduce((acc, item) => {
      acc[item.value] = "";
      return acc;
    }, {})
  );
  const [totalRecords, setTotalRecords] = useState(0);
  const [checkedRows, setCheckedRows] = useState([]);
  const [isModifyMappingButtonLoad, setIsModifyMappingButtonLoad] =
    useState(false);
  const [modelDelete, setModelDelete] = useState(false);
  const [modelSave, setModelSave] = useState(false);
  const [isDeleteMappingButtonLoad, setIsDeleteMappingButtonLoad] =
    useState(false);

  const allChecked =
    mappingAllList?.list?.length > 0 &&
    checkedRows.length === mappingAllList?.list?.length;

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "module_list",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setModuleAllList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (mappingData?.module_type) {
      let typeKey = "";
      if (mappingData.module_type === 1) {
        typeKey = "part_brand_column";
      } else if (mappingData.module_type === 2) {
        typeKey = "part_side_column";
      } else if (mappingData.module_type === 3) {
        typeKey = "part_group_column";
      } else if (mappingData.module_type === 4) {
        typeKey = "part_location_column";
      } else if (mappingData.module_type === 5) {
        typeKey = "part_type_column";
      } else {
        typeKey = ""; // optional fallback
      }

      const data = {
        limit: 20,
        page: 1,
        search: "",
        type: typeKey,
      };

      getCommonSearchList(data)
        .then((response) => {
          const list = response.data.data.map((item) => ({
            value: item.id,
            label: item.name,
          }));

          setModuleColAllList(list);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [mappingData.module_type]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1;
    }
    setParams(paramsObj);
  };

  const handleImportFileSubmit = (e) => {
    e.preventDefault();

    setIsModifyButtonLoad(true);
    const formData = new FormData();
    formData.append("file", file);

    mappingImportFile(formData)
      .then((response) => {
        toast.success(response.data.message);
        setMappingAllList(response.data);
        setTotalRecords(response.data.totalRecords);

        setIsModifyButtonLoad(false);
        setFile(null);

        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsModifyButtonLoad(false);
      });
  };

  const getPayloadColumnMapping = () => {
    const payloadMapping = {};
    mappingAllList?.headers?.forEach((headerKey, index) => {
      if (columnMappings[headerKey]) {
        payloadMapping[columnMappings[headerKey]] = `col${index + 1}`;
      }
    });
    return payloadMapping;
  };

  const generateRowPayload = () => {
    return checkedRows.map((rowIndex) => {
      return mappingAllList.list[rowIndex];
    });
  };

  const convertToColPayload = (dataArray, headersOrder) => {
    return dataArray.map((row) => {
      const newRow = {};
      headersOrder.forEach((headerKey, index) => {
        newRow[`col${index + 1}`] = row[headerKey] || "";
      });
      return newRow;
    });
  };

  const payloadRows = convertToColPayload(
    generateRowPayload(),
    mappingAllList.headers
  );

  const handleMappingSubmit = (e) => {
    e.preventDefault();

    setIsModifyMappingButtonLoad(true);
    let data = {
      module_type: mappingData?.module_type,
      rows: payloadRows,
      columnMapping: getPayloadColumnMapping(),
    };

    createMappingStore(data)
      .then((response) => {
        toast.success(response.data.message);
        setIsModifyMappingButtonLoad(false);
        setColumnMappings({});
        setCheckedRows([]);
        setModelSave(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsModifyMappingButtonLoad(false);
      });
  };

  const handleDeleteMultiple = () => {
    const sortedIndexes = [...checkedRows].sort((a, b) => b - a);

    let updatedList = [...mappingAllList.list];

    sortedIndexes.forEach((rowIndex) => {
      updatedList.splice(rowIndex, 1);
    });

    setMappingAllList((prev) => ({
      ...prev,
      list: updatedList,
    }));

    setCheckedRows([]);
    setModelDelete(false);
  };

  const handleMappingClose = () => {
    setModelSave(false);
  };

  const handleDeleteMappingClose = () => {
    setModelDelete(false);
  };

  const handleCellChange = (rowIndex, header, value) => {
    setMappingAllList((prev) => ({
      ...prev,
      list: prev.list.map((row, i) =>
        i === rowIndex ? { ...row, [header]: value } : row
      ),
    }));
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1>Mapping</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right"></ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-primary">
                <div className="row justify-content-start p-3">
                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {"Select Module Type"}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div ">
                          <Select
                            options={moduleAllList}
                            value={moduleAllList.find(
                              (option) =>
                                option.value === mappingData.module_type
                            )}
                            onChange={(selectedOption) =>
                              setMappingData({
                                ...mappingData,
                                module_type: selectedOption.value,
                                module_type_name: selectedOption.label,
                              })
                            }
                            placeholder={"Select Module Type"}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("select_file")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control"
                            type="file"
                            onChange={(e) => setFile(e.target.files[0])}
                            name="file"
                            accept=".csv,.xlsx"
                            ref={fileInputRef}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleImportFileSubmit}
                      disabled={isModifyButtonLoad}
                      style={{ width: "127px", marginTop: "43px" }}
                    >
                      {isModifyButtonLoad ? (
                        <>
                          <i className="fa fa-circle-o-notch fa-spin me-2"></i>
                          Loading...
                        </>
                      ) : (
                        <>
                          {t("submit")} <i className="bi bi-check2"></i>
                        </>
                      )}
                    </button>
                  </div>
                </div>

                {mappingAllList?.headers?.length > 0 && (
                  <div className="row">
                    <div className="col-md-12">
                      <div
                        className="vehicleThBg table-responsive tableScroll table-scroll-modal min-height-0"
                        style={{ height: "500px" }}
                      >
                        <table className="rounded-table table table-striped table-bordered table-hover">
                          <thead>
                            <tr>
                              <th></th>
                              {mappingAllList?.headers?.map(
                                (headerKey, index) => (
                                  <th key={index}>
                                    <div className="col-xl-12">
                                      <div className="input-div ">
                                        <Select
                                          options={moduleColAllList}
                                          value={
                                            moduleColAllList.find(
                                              (option) =>
                                                option.value ===
                                                columnMappings[headerKey]
                                            ) || null
                                          }
                                          onChange={(selectedOption) => {
                                            const selectedValue =
                                              selectedOption?.value;

                                            const isDuplicate = Object.keys(
                                              columnMappings
                                            ).some(
                                              (key) =>
                                                key !== headerKey &&
                                                columnMappings[key] ===
                                                  selectedValue
                                            );

                                            if (isDuplicate) {
                                              toast.error(
                                                `"${selectedValue}" is already selected in another column!`
                                              );
                                              return;
                                            }

                                            setColumnMappings((prev) => ({
                                              ...prev,
                                              [headerKey]: selectedValue || "",
                                            }));
                                          }}
                                          placeholder={"Select Column"}
                                          isClearable
                                        />
                                      </div>
                                    </div>
                                  </th>
                                )
                              )}
                            </tr>
                          </thead>

                          <thead>
                            <tr>
                              <th>
                                <input
                                  type="checkbox"
                                  checked={allChecked}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setCheckedRows(
                                        mappingAllList?.list?.map(
                                          (_, idx) => idx
                                        )
                                      );
                                    } else {
                                      setCheckedRows([]);
                                    }
                                  }}
                                />
                              </th>
                              {mappingAllList?.headers?.map((item, index) => (
                                <th key={index}>{item}</th>
                              ))}
                            </tr>
                          </thead>

                          <tbody>
                            {mappingAllList?.list?.length > 0 ? (
                              mappingAllList?.list?.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={checkedRows.includes(rowIndex)}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setCheckedRows((prev) => [
                                            ...prev,
                                            rowIndex,
                                          ]);
                                        } else {
                                          setCheckedRows((prev) =>
                                            prev.filter(
                                              (idx) => idx !== rowIndex
                                            )
                                          );
                                        }
                                      }}
                                    />
                                  </td>

                                  {mappingAllList?.headers?.map(
                                    (header, colIndex) => (
                                      <td key={colIndex}>
                                        {/* {row?.[header] ?? "-"} */}
                                        <input
                                          type="text"
                                          value={row?.[header] ?? ""}
                                          onChange={(e) =>
                                            handleCellChange(
                                              rowIndex,
                                              header,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                    )
                                  )}
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan={mappingAllList?.headers?.length || 1}
                                >
                                  No results found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <div className="card-footer clearfix card-footer-part d-none">
                        <div className="pagination pagination-sm m-0 float-right">
                          <ReactPaginate
                            previousLabel={
                              <i className="bi bi-chevron-double-left"></i>
                            }
                            nextLabel={
                              <i className="bi bi-chevron-double-right"></i>
                            }
                            breakLabel={"..."}
                            pageCount={Math.ceil(totalRecords / params.limit)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(e) => handleParams(e, "pagination")}
                            forcePage={params.page - 1}
                            containerClassName={"pagination"}
                            activeClassName={"active"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {checkedRows?.length > 0 &&
                  mappingAllList?.headers?.length > 0 && (
                    <div className="row mb-3">
                      <div className="d-flex justify-content-end gap-2">
                        <button
                          type="button"
                          className="btn"
                          onClick={() => setModelDelete(true)}
                          style={{
                            width: "127px",
                            marginTop: "43px",
                            color: "#ffffff",
                            backgroundColor: "#dc3545",
                            borderColor: "#dc3545",
                          }}
                        >
                          {t("delete")} <i className="bi bi-trash"></i>
                        </button>

                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={() => setModelSave(true)}
                          style={{ width: "127px", marginTop: "43px" }}
                        >
                          {t("save")} <i className="bi bi-check2"></i>
                        </button>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>

        <Modal isOpen={modelSave}>
          <ModalHeader>{t("mapping")}</ModalHeader>
          <ModalBody>
            <p className={`mb-0`}>{t("save_mapping_data")}</p>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              disabled={isModifyMappingButtonLoad}
              onClick={handleMappingClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Close <i className="bi bi-x-lg"></i>
            </button>

            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleMappingSubmit}
              disabled={isModifyMappingButtonLoad}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {isModifyMappingButtonLoad ? (
                <>
                  <i className="fa fa-circle-o-notch fa-spin me-2"></i>
                  Loading...
                </>
              ) : (
                <>
                  {t("save")} <i className="bi bi-check2"></i>
                </>
              )}
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={modelDelete}>
          <ModalHeader>{t("mapping")}</ModalHeader>
          <ModalBody>
            <p className={`mb-0`}>{t("delete_mapping_data")}</p>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              disabled={isDeleteMappingButtonLoad}
              onClick={handleDeleteMappingClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Close <i className="bi bi-x-lg"></i>
            </button>

            <button
              type="button"
              className="btn btn-block"
              onClick={handleDeleteMultiple}
              disabled={isDeleteMappingButtonLoad}
              style={{
                width: "100px",
                marginTop: "10px",
                color: "#ffffff",
                backgroundColor: "#dc3545",
                borderColor: "#dc3545",
              }}
            >
              {t("delete")} <i className="bi bi-trash"></i>
            </button>
          </ModalFooter>
        </Modal>
      </section>
    </div>
  );
};

export default Mapping;
